const $body = $(document.body);

const $ctaWrapper = $('.m1-ta-cta');

$ctaWrapper.find('.m1-ta-cta__wrapper').one('click', () => {
  gtmDataLayer.push({
    event: 'listenThisArticle',
  });
  const { id, lang } = $ctaWrapper.data();
  $ctaWrapper.replaceWith(`<div class="trinityAudioPlaceholder"/>`);
  const textSelector = '.m1-article-title, .preview, .description';
  const js = document.createElement('script');
  js.type = 'text/javascript';
  js.setAttribute('data-player-id', 'trinity-audio-player');
  js.src =
    `https://trinitymedia.ai/player/trinity/${id}/?pageURL=$$PAGE_URL$$&GDPR=$$GDPR_MACRO$$&GDPR_CONSENT=$$GDPR_CONSENT_MACRO$$&textSelector=` +
    encodeURIComponent(btoa(textSelector)) +
    '&language=' + lang;
  document.head.appendChild(js);
});